import '../styles.css';

export default function Footer({ showIndustries = true }: { showIndustries?: boolean }) {
  const year = new Date().getFullYear();
  return (
    <footer className="footer-aw" role="contentinfo">
      <div className="footer-aw-top">
        <div className="footer-aw-brand">
          <img src="/images/weblogowhite.png" alt="AfricaWeather" className="footer-aw-logo" />
        </div>
        <div className={`footer-aw-cols${showIndustries ? '' : ' two'}`}>
          <div className="footer-aw-col">
            <div className="footer-aw-title">Get In Touch</div>
            <div className="footer-aw-item">
              <IconGeo />
              <div className="footer-aw-text">
                First Floor, Building 15
                <br />Woodlands Office Park
                <br />20 Woodlands Drive
                <br />Woodmead 2080
              </div>
            </div>
            <div className="footer-aw-item">
              <IconMail />
              <a href="mailto:sales@africaweather.com" className="footer-aw-link">sales@africaweather.com</a>
            </div>
            <div className="footer-aw-item">
              <IconPhone />
              <a href="tel:+27113007480" className="footer-aw-link">+27 (0)11-300 7480</a>
            </div>
            <div className="footer-aw-social">
              <a className="footer-aw-socialbtn" href="https://twitter.com/africaweather_" aria-label="Twitter" target="_blank" rel="noreferrer">
                <IconTwitter />
              </a>
              <a className="footer-aw-socialbtn" href="https://www.facebook.com/AfricaWeather" aria-label="Facebook" target="_blank" rel="noreferrer">
                <IconFacebook />
              </a>
              <a className="footer-aw-socialbtn" href="https://www.linkedin.com/company/10460987" aria-label="LinkedIn" target="_blank" rel="noreferrer">
                <IconLinkedIn />
              </a>
            </div>
          </div>
          {showIndustries && (
            <div className="footer-aw-col">
              <div className="footer-aw-title">Industries</div>
              <div className="footer-aw-links">
                <a className="footer-aw-link" href="https://africaweather.com/industries/insurance" target="_blank" rel="noreferrer"><Arrow />Insurance</a>
                <a className="footer-aw-link" href="https://africaweather.com/industries/mining" target="_blank" rel="noreferrer"><Arrow />Mining</a>
                <a className="footer-aw-link" href="https://africaweather.com/industries/schools-and-universities" target="_blank" rel="noreferrer"><Arrow />Schools and Universities</a>
                <a className="footer-aw-link" href="https://africaweather.com/industries/sporting" target="_blank" rel="noreferrer"><Arrow />Sporting Facilities</a>
              </div>
            </div>
          )}
          <div className="footer-aw-col">
            <div className="footer-aw-title">Company</div>
            <div className="footer-aw-links">
              <a className="footer-aw-link" href="https://africaweather.com/" target="_blank" rel="noreferrer"><Arrow />Home</a>
              <a className="footer-aw-link" href="https://africaweather.com/about" target="_blank" rel="noreferrer"><Arrow />About Us</a>
              <a className="footer-aw-link" href="https://africaweather.com/contact" target="_blank" rel="noreferrer"><Arrow />Contact Us</a>
              <a className="footer-aw-link" href="https://africaweather.com/legal/privacypolicy" target="_blank" rel="noreferrer"><Arrow />Privacy Policy</a>
              <a className="footer-aw-link" href="https://v1.africaweather.com/resources/AfricaWeather_Business_Terms_and_Conditions.pdf" target="_blank" rel="noreferrer"><Arrow />Business Terms and Conditions</a>
              <a className="footer-aw-link" href="https://v1.africaweather.com/resources/AfricaWeather_Business_Terms_and_Conditions.pdf" target="_blank" rel="noreferrer"><Arrow />POPI Contract Terms</a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-aw-bottom">
        <div>© {year} <a className="footer-aw-link" href="https://www.africaweather.com/" target="_blank" rel="noreferrer">https://www.africaweather.com</a> .All Rights Reserved.</div>
      </div>
    </footer>
  );
}

function Arrow() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 8 }}>
      <path d="M5 12h14M13 5l7 7-7 7" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
function IconGeo() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 8 }}>
      <path d="M12 22s7-6.2 7-12a7 7 0 10-14 0c0 5.8 7 12 7 12z" stroke="#3b82f6" strokeWidth="2"/>
      <circle cx="12" cy="10" r="2.5" stroke="#3b82f6" strokeWidth="2"/>
    </svg>
  );
}
function IconMail() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 8 }}>
      <path d="M4 6h16v12H4z" stroke="#3b82f6" strokeWidth="2"/>
      <path d="M4 7l8 6 8-6" stroke="#3b82f6" strokeWidth="2"/>
    </svg>
  );
}
function IconPhone() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 8 }}>
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.86 19.86 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.86 19.86 0 012.08 4.2 2 2 0 014.06 2h3a2 2 0 012 1.72c.12.89.31 1.76.57 2.6a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.48-1.09a2 2 0 012.11-.45c.84.26 1.71.45 2.6.57A2 2 0 0122 16.92z" stroke="#3b82f6" strokeWidth="2"/>
    </svg>
  );
}
function IconTwitter() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 5.92c-.77.35-1.6.58-2.47.69a4.3 4.3 0 001.88-2.39 8.6 8.6 0 01-2.73 1.04 4.29 4.29 0 00-7.31 3.91A12.18 12.18 0 013 4.67a4.28 4.28 0 001.33 5.72 4.24 4.24 0 01-1.95-.54v.05a4.3 4.3 0 003.44 4.21 4.3 4.3 0 01-1.94.07 4.3 4.3 0 004.01 2.98A8.6 8.6 0 012 19.54a12.14 12.14 0 006.58 1.93c7.9 0 12.22-6.55 12.22-12.23l-.01-.56A8.73 8.73 0 0022 5.92z"/>
    </svg>
  );
}
function IconFacebook() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 12a10 10 0 10-11.6 9.87v-6.98h-2.5V12h2.5V9.8c0-2.47 1.47-3.84 3.72-3.84 1.08 0 2.2.19 2.2.19v2.42h-1.24c-1.22 0-1.6.76-1.6 1.54V12h2.73l-.44 2.89h-2.3v6.98A10 10 0 0022 12z"/>
    </svg>
  );
}
function IconLinkedIn() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.05-1.86-3.05-1.86 0-2.15 1.45-2.15 2.95v5.67H9.34V9h3.41v1.56h.05c.48-.9 1.64-1.86 3.38-1.86 3.62 0 4.29 2.38 4.29 5.48v6.27zM5.34 7.43a2.06 2.06 0 110-4.12 2.06 2.06 0 010 4.12zM7.12 20.45H3.56V9h3.56v11.45z"/>
    </svg>
  );
}
